import {
  apiKey,
  authDomain,
  databaseURL,
  projectId,
} from './constants'

export const firebase = {
  apiKey,
  authDomain,
  databaseURL,
  projectId,
}

export const rrfConfig = {
  userProfile: 'users',
  useFirestoreForProfile: true, // Store in Firestore instead of Real Time DB
  enableLogging: false
}

export default { firebase, rrfConfig }



// WEBPACK FOOTER //
// ./src/config/fb.js